import * as React from "react";

interface MinusButtonProps {
  className?: string;
  color?: string;
  onClick?: () => void;
}

export default function MinusButton({
  className,
  color,
  onClick,
}: MinusButtonProps) {
  return (
    <div className={className} onClick={onClick}>
      <svg
        width="23"
        height="3"
        viewBox="0 0 23 3"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="23" height="3" fill={color || "#0099FE"} />
      </svg>
    </div>
  );
}
